const sbCountries = [
  { countryCode: 'US', label: 'United States of America' },
  { countryCode: 'AL', label: 'Albania' },
  { countryCode: 'DZ', label: 'Algeria' },
  { countryCode: 'AR', label: 'Argentina' },
  { countryCode: 'AU', label: 'Australia' },
  { countryCode: 'AT', label: 'Austria' },
  { countryCode: 'AZ', label: 'Azerbaijan' },
  { countryCode: 'BH', label: 'Bahrain' },
  { countryCode: 'BE', label: 'Belgium' },
  { countryCode: 'BO', label: 'Bolivia' },
  { countryCode: 'BA', label: 'Bosnia and Herzegovina' },
  { countryCode: 'BR', label: 'Brazil' },
  { countryCode: 'BG', label: 'Bulgaria' },
  { countryCode: 'CA', label: 'Canada' },
  { countryCode: 'CL', label: 'Chile' },
  { countryCode: 'C2', label: 'China' },
  { countryCode: 'CO', label: 'Colombia' },
  { countryCode: 'CR', label: 'Costa Rica' },
  { countryCode: 'CY', label: 'Cyprus' },
  { countryCode: 'CZ', label: 'Czech Republic' },
  { countryCode: 'DK', label: 'Denmark' },
  { countryCode: 'DO', label: 'Dominican Republic' },
  { countryCode: 'EG', label: 'Egypt' },
  { countryCode: 'SV', label: 'El Salvador' },
  { countryCode: 'EE', label: 'Estonia' },
  { countryCode: 'FI', label: 'Finland' },
  { countryCode: 'FR', label: 'France' },
  { countryCode: 'DE', label: 'Germany' },
  { countryCode: 'GR', label: 'Greece' },
  { countryCode: 'GT', label: 'Guatemala' },
  { countryCode: 'HN', label: 'Honduras' },
  { countryCode: 'HK', label: 'Hong Kong SAR China' },
  { countryCode: 'HU', label: 'Hungary' },
  { countryCode: 'IS', label: 'Iceland' },
  { countryCode: 'IN', label: 'India' },
  { countryCode: 'ID', label: 'Indonesia' },
  { countryCode: 'IE', label: 'Ireland' },
  { countryCode: 'IL', label: 'Israel' },
  { countryCode: 'IT', label: 'Italy' },
  { countryCode: 'JM', label: 'Jamaica' },
  { countryCode: 'JP', label: 'Japan' },
  { countryCode: 'JO', label: 'Jordan' },
  { countryCode: 'KZ', label: 'Kazakhstan' },
  { countryCode: 'KE', label: 'Kenya' },
  { countryCode: 'KW', label: 'Kuwait' },
  { countryCode: 'KG', label: 'Kyrgyzstan' },
  { countryCode: 'LV', label: 'Latvia' },
  { countryCode: 'LU', label: 'Luxembourg' },
  { countryCode: 'MY', label: 'Malaysia' },
  { countryCode: 'MU', label: 'Mauritius' },
  { countryCode: 'MX', label: 'Mexico' },
  { countryCode: 'MA', label: 'Morocco' },
  { countryCode: 'NL', label: 'Netherlands' },
  { countryCode: 'NZ', label: 'New Zealand' },
  { countryCode: 'NO', label: 'Norway' },
  { countryCode: 'OM', label: 'Oman' },
  { countryCode: 'PA', label: 'Panama' },
  { countryCode: 'PE', label: 'Peru' },
  { countryCode: 'PL', label: 'Poland' },
  { countryCode: 'PT', label: 'Portugal' },
  { countryCode: 'QA', label: 'Qatar' },
  { countryCode: 'RO', label: 'Romania' },
  { countryCode: 'SA', label: 'Saudi Arabia' },
  { countryCode: 'SN', label: 'Senegal' },
  { countryCode: 'SG', label: 'Singapore' },
  { countryCode: 'SK', label: 'Slovakia' },
  { countryCode: 'SI', label: 'Slovenia' },
  { countryCode: 'ZA', label: 'South Africa' },
  { countryCode: 'KR', label: 'South Korea' },
  { countryCode: 'ES', label: 'Spain' },
  { countryCode: 'SE', label: 'Sweden' },
  { countryCode: 'CH', label: 'Switzerland' },
  { countryCode: 'TJ', label: 'Tajikistan' },
  { countryCode: 'TN', label: 'Tunisia' },
  { countryCode: 'TR', label: 'Turkey' },
  { countryCode: 'TM', label: 'Turkmenistan' },
  { countryCode: 'AE', label: 'United Arab Emirates' },
  { countryCode: 'GB', label: 'United Kingdom' },
  { countryCode: 'UY', label: 'Uruguay' },
  { countryCode: 'VE', label: 'Venezuela' },
  { countryCode: 'YE', label: 'Yemen' },
]

const cardOptions = [
  {
    primaryText: 'Visa',
    value: 'Visa',
  },
  {
    primaryText: 'MasterCard',
    value: 'MasterCard',
  },
  {
    primaryText: 'American Express',
    value: 'Amex',
  },
  {
    primaryText: 'Discover',
    value: 'Discover',
  },
  {
    primaryText: 'Maestro',
    value: 'Maestro',
  },
  {
    primaryText: 'JCB',
    value: 'JCB',
  },
  {
    primaryText: 'ELO - Brazil',
    value: 'ELO_BR',
  },
]

const currencyBinMap = {
  USD_TYPE_CARD_VISA: '403203',
  USD_TYPE_CARD_MASTERCARD: '511092',
  GBP_TYPE_CARD_VISA: '469846',
  GBP_TYPE_CARD_MASTERCARD: '542854',
  GBP_TYPE_CARD_SWITCH: '675906',
  EUR_TYPE_CARD_VISA: '402002',
  EUR_TYPE_CARD_MASTERCARD: '523210',
  AUD_TYPE_CARD_VISA: '423953',
  AUD_TYPE_CARD_MASTERCARD: '512576',
  CAD_TYPE_CARD_VISA: '421402',
  CAD_TYPE_CARD_MASTERCARD: '531780',
  JPY_TYPE_CARD_VISA: '452591',
  JPY_TYPE_CARD_MASTERCARD: '528386',
  MXN_TYPE_CARD_VISA: '416502,477213,477291,493162,494133',
  MXN_TYPE_CARD_MASTERCARD: '547080',
  MXN_TYPE_CARD_AMEX: '370786',
  BRL_TYPE_CARD_VISA: '410863,422003,422061,491674',
  BRL_TYPE_CARD_MASTERCARD:
    '516230, 524820, 525823, 542976, 544731, 548590,549167',
  TRY_TYPE_CARD_VISA: '407461',
  SGD_TYPE_CARD_VISA: '409636',
  SGD_TYPE_CARD_MASTERCARD: '542113',
  PLN_TYPE_CARD_VISA: '406333',
  PLN_TYPE_CARD_MASTERCARD: '522471',
  MYR_TYPE_CARD_VISA: '429312',
  MYR_TYPE_CARD_MASTERCARD: '540007',
  RUB_TYPE_CARD_VISA:
    '462758643,462758610,462758978,462758840,462758608,462758600',
  RUB_TYPE_CARD_MASTERCARD: '527594',
  RUB_TYPE_CARD_MAESTRO: '676280',
  INR_TYPE_CARD_VISA: '486337',
  INR_TYPE_CARD_MASTERCARD: '524178',
  ILS_TYPE_CARD_VISA: '458043',
  ILS_TYPE_CARD_MASTERCARD: '532610',
  ILS_TYPE_CARD_AMEX: '375987',
  KRW_TYPE_CARD_VISA: '411904',
  KRW_TYPE_CARD_MASTERCARD: '515594',
  KRW_TYPE_CARD_AMEX: '379183',
  IDR_TYPE_CARD_VISA: '410505',
  IDR_TYPE_CARD_MASTERCARD: '524125',
  THB_TYPE_CARD_VISA: '453215',
  THB_TYPE_CARD_MASTERCARD: '540492',
  PHP_TYPE_CARD_VISA: '402822',
  PHP_TYPE_CARD_MASTERCARD: '545143',
  NOK_TYPE_CARD_VISA: '402960',
  NOK_TYPE_CARD_MASTERCARD: '540123',
  DKK_TYPE_CARD_VISA: '417577',
  DKK_TYPE_CARD_MASTERCARD: '544756',
  SEK_TYPE_CARD_VISA: '466554',
  SEK_TYPE_CARD_MASTERCARD: '548945',
  CHF_TYPE_CARD_VISA: '405911',
  CHF_TYPE_CARD_MASTERCARD: '540108',
}

const countryCurrency = {
  US: 'USD',
  GB: 'GBP',
  IT: 'EUR',
  ES: 'EUR',
  AU: 'AUD',
  CA: 'CAD',
  DE: 'EUR',
  FR: 'EUR',
  HK: 'HKD',
  JP: 'JPY',
  MX: 'MXN',
  NL: 'EUR',
  BR: 'BRL',
  C2: 'USD',
  NZ: 'NZD',
  TR: 'TRY',
  SG: 'SGD',
  RU: 'RUB',
  CH: 'CHF',
  AT: 'EUR',
  IN: 'USD',
  PL: 'PLN',
  MY: 'MYR',
  IL: 'ILS',
  BE: 'EUR',
  LU: 'EUR',
  FI: 'EUR',
  CZ: 'CZK',
  SK: 'EUR',
  HU: 'HUF',
  GR: 'EUR',
  SE: 'SEK',
  NO: 'NOK',
  DK: 'DKK',
  MA: 'USD',
  DZ: 'USD',
  TN: 'USD',
  EG: 'USD',
  JO: 'USD',
  KW: 'USD',
  BH: 'USD',
  QA: 'USD',
  SA: 'USD',
  AE: 'USD',
  OM: 'USD',
  YE: 'USD',
  AZ: 'USD',
  TM: 'USD',
  KG: 'USD',
  TJ: 'USD',
  KZ: 'USD',
  KR: 'USD',
  ZA: 'USD',
  KE: 'USD',
  IE: 'EUR',
  PT: 'EUR',
  CY: 'EUR',
  MU: 'USD',
  SN: 'USD',
  SI: 'EUR',
  LV: 'EUR',
  EE: 'EUR',
  AR: 'USD',
  BO: 'USD',
  CL: 'USD',
  CO: 'USD',
  CR: 'USD',
  DO: 'USD',
  GT: 'USD',
  SV: 'USD',
  HN: 'USD',
  JM: 'USD',
  PA: 'USD',
  PE: 'USD',
  UY: 'USD',
  VE: 'USD',
  ID: 'USD',
  TH: 'THB',
  RO: 'EUR',
  AL: 'USD',
  BA: 'USD',
  BG: 'EUR',
}

const CardTypes = {
  visa: {
    prefixList: [403203], // US DEFAULT
    digitCount: 16,
    cvvCount: 3,
  },
  mastercard: {
    prefixList: [511092], // US DEFAULT
    digitCount: 16,
    cvvCount: 3,
  },
  amex: {
    prefixList: [34, 37],
    digitCount: 15,
    cvvCount: 4,
  },
  discover: {
    prefixList: [6011],
    digitCount: 16,
    cvvCount: 3,
  },
  maestro: {
    prefixList: [5018, 5020, 5038, 5893],
    digitCount: 16,
    cvvCount: 3,
  },
  jcb: {
    prefixList: [353, 354, 355, 356, 357],
    digitCount: 16,
    cvvCount: 3,
  },
  elo_br: {
    // ELO [Installments] - Brazil
    prefixList: [506727, 636368],
    digitCount: 16,
    cvvCount: 3,
  },
}

export { sbCountries, cardOptions, currencyBinMap, countryCurrency, CardTypes }
